import { formatInSiteTz, placeTimeLabel, siteTz, tzOffsetMin, tzZoneName, fmtHours } from "@/lib/datetime";

const DT = { year: undefined, weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", hour12: false };
const T = { year: undefined, month: undefined, day: undefined, hour: "2-digit", minute: "2-digit", hour12: false };

// Booking time in site time with a "Town STATE time · zone" label, plus an amber
// line when the phone's time zone differs from the site's.
export default function DriverSiteTime({ start, end, site, testId = "driver-site-time" }) {
  if (!start) return <span data-testid={testId}>—</span>;
  const tz = siteTz(site);
  const at = new Date(start).getTime();
  const phoneTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const diff = tzOffsetMin(phoneTz, at) - tzOffsetMin(tz, at);
  return (
    <span className="inline-flex flex-col" data-testid={testId}>
      <span>
        <strong>{formatInSiteTz(start, tz, DT)}{end ? ` → ${formatInSiteTz(end, tz, T)}` : ""}</strong>
        <span className="ml-1 text-[11px] text-slate-500" data-testid={`${testId}-label`}>({placeTimeLabel(site, start)})</span>
      </span>
      {diff !== 0 && (
        <span className="text-[11px] text-amber-700" data-testid={`${testId}-phone`}>
          Your phone: {formatInSiteTz(start, phoneTz, T)} {tzZoneName(phoneTz, at)} ({fmtHours(diff)} {diff > 0 ? "ahead of" : "behind"} site). Arrive by site time.
        </span>
      )}
    </span>
  );
}
